import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Google
 * id D1AD4F4E-3CFE-4F51-932D-D3942A26C418
 * name toggle-switch
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/toggle-switch.svg
 * tags
 */
export const ToggleSwitchIcon = createSvgIcon(<><path d="M17,7H7A5,5 0 0,0 2,12A5,5 0 0,0 7,17H17A5,5 0 0,0 22,12A5,5 0 0,0 17,7M17,15A3,3 0 0,1 14,12A3,3 0 0,1 17,9A3,3 0 0,1 20,12A3,3 0 0,1 17,15Z" /></>, 'ToggleSwitchIcon');
export default ToggleSwitchIcon